import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
// render - sample page

const Actividad = Loadable(lazy(() => import('pages/actividad/actividad')));
const ActividadesTemplate = Loadable(lazy(() => import('pages/actividadTemplate/actividadTemplate')));
const Pedidos = Loadable(lazy(() => import('pages/pedidos/pedidos')));
const Materiales = Loadable(lazy(() => import('pages/materiales/materiales')));
const Remitos = Loadable(lazy(() => import('pages/remitos/remitos')));
const Estadisticas = Loadable(lazy(() => import('pages/estadisticas/estadisticas')));
const Usuarios = Loadable(lazy(() => import('pages/usuarios/usuarios')));
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/interno',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'actividades',
          element: <Actividad />
        },
        {
          path: 'actividades/template',
          element: <ActividadesTemplate />
        },
        {
          path: 'pedidos',
          element: <Pedidos />
        },
        {
          path: 'materiales',
          element: <Materiales />
        },
        {
          path: 'remitos',
          element: <Remitos />
        }
        ,
        {
          path: 'estadisticas',
          element: <Estadisticas />
        }
        ,
        {
          path: 'usuarios',
          element: <Usuarios />
        }
      ]
    }
  ]
};

export default MainRoutes;
